import { Component, OnInit, EventEmitter, Input, Output, AfterViewInit, ViewChild } from '@angular/core';
import { MediaObserver, MediaChange } from '@angular/flex-layout';

import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';

import { environment } from '../../../environments/environment';
import { ErrorHandler, HandleError } from '../../services/error-handler.service';
import { PaymentService } from 'src/app/services/payment.service';

import { NoteTotalAmountPaidItem } from 'src/app/models/payment';

@Component({
  selector: 'app-note-total-amount-paid',
  templateUrl: './note-total-amount-paid.component.html',
  styleUrls: ['./note-total-amount-paid.component.scss']
})
export class NoteTotalAmountPaidComponent implements OnInit, AfterViewInit {
  private _participantId = null;
  private _noteId = null;

  @Input()
  set participantId(participantId: number) {
    this._participantId = participantId || null;
    this.getData();
  }
  get participantId(): number {
    return this._participantId;
  }

  @Input()
  set noteId(noteId: number) {
    this._noteId = noteId || null;
    this.getData();
  }
  get noteId(): number {
    return this._noteId;
  }

  @Output() dataReturned = new EventEmitter<NoteTotalAmountPaidItem[]>();

  // Have to use the following ElementDisplayStyle variables and ngStyle to show/hide table elements
  // This because the table paginator will not attach correctly otherwise - this is a work around for a known issue
  private _hideElementDisplayStyle = 'none';
  private _showElementDisplayStyle = 'inline';
  private _showElementDisplayStyleIE = 'inline-block';

  private _handleError: HandleError;
  private _logging = environment.logging;

  isBrowserIE = /msie\s|trident\//i.test(window.navigator.userAgent);

  showSpinner = false;

  noteTotalAmountPaid: NoteTotalAmountPaidItem[] = [];

  // DataTable
  tableDisplayedColumns = [
    'paymentType',
    'paymentAmount',
    'principalAmountApplied',
    'interestAmountApplied',
    'feeAmount'
  ];
  tableDataSource = new MatTableDataSource<NoteTotalAmountPaidItem>(this.noteTotalAmountPaid);
  tableDisplayStyle: string = this._hideElementDisplayStyle;
  tableDisplayStyleIE: string = this._hideElementDisplayStyle;
  noteTotalAmountPaidFound = false;

  constructor(private _errorHandler: ErrorHandler, private _paymentService: PaymentService, public media: MediaObserver) {
    this._handleError = _errorHandler.createHandleError('NoteTotalAmountPaidComponent');
  }

  ngOnInit() {
    this.noteTotalAmountPaidFound = true;
    this.tableDisplayStyle = this.noteTotalAmountPaidFound ? this._showElementDisplayStyle : this._hideElementDisplayStyle;
    this.tableDisplayStyleIE = this.noteTotalAmountPaidFound ? this._showElementDisplayStyleIE : this._hideElementDisplayStyle;
  }

  ngAfterViewInit() {}

  getData(): void {
    if (this._noteId !== null) {
      this.showSpinner = true;
      this.getNoteTotalAmountPaid(this._noteId, this._participantId);
    }
  }

  getNoteTotalAmountPaid(noteId: number, participantId: number): void {
    this.showSpinner = true;
    this._paymentService.getNoteTotalAmountPaid(noteId, participantId).subscribe(
      resultArray => {
        this.noteTotalAmountPaid = resultArray;
        if (this._logging.serviceCallTraceLog) {
          console.log('NoteTotalAmountPaidComponent.getNoteTotalAmountPaid :: result.length = ' + resultArray.length);
        }
        if (this._logging.serviceDataTraceLog) {
          console.log('NoteTotalAmountPaidComponent.getNoteTotalAmountPaid :: result = ' + JSON.stringify(resultArray));
        }
        this.tableDataSource = new MatTableDataSource<NoteTotalAmountPaidItem>(this.noteTotalAmountPaid);
        this.noteTotalAmountPaidFound = resultArray.length > 0;
        this.tableDisplayStyle = this.noteTotalAmountPaidFound ? this._showElementDisplayStyle : this._hideElementDisplayStyle;
        this.tableDisplayStyleIE = this.noteTotalAmountPaidFound
          ? this._showElementDisplayStyleIE
          : this._hideElementDisplayStyle;
        this.dataReturned.emit(this.noteTotalAmountPaid);
        this.getDataComplete();
      },
      error => this._handleError('getNoteTotalAmountPaid', error)
    );
  }

  getDataComplete(): void {
    this.showSpinner = false;
  }
}
